/* eslint-disable import/prefer-default-export */
export const NAV_ITEMS = [
  { label: 'Story', value: '/' },
  { label: 'Messages', value: 'messages' },
  { label: 'Myself', value: 'myself' },
  { label: 'Possessions', value: 'possessions' },
  { label: 'Bazaar', value: 'bazaar' },
  { label: 'Fate', value: 'fate' },
  { label: 'Plans', value: 'plans' },
];